import React from 'react';
import classNames from 'classnames';

import styles from './Label.module.scss';

export default function Label({
  children,
  classes,
  htmlFor,
  required,
}: LabelType): JSX.Element {
  return (
    <label
      htmlFor={htmlFor}
      className={classNames(styles.label, classes?.label, {
        [styles.required]: required,
      })}
    >
      {children}
    </label>
  );
}

type LabelType = React.PropsWithChildren<{
  classes?: LabelClassesType;
  htmlFor: string;
  required?: boolean;
}>;

export type LabelClassesType = {
  label?: string;
};
